import { PresetSet } from './preset';
import { Product } from './product';

export class Config {

    constructor(
        public readonly product: Product,
        public readonly presetSet: PresetSet,
    ) { }
}
